// extracted by mini-css-extract-plugin
export var askAiIcon = "_kg-9";
export var container = "_kg-0";
export var groupSeparator = "_kg-a";
export var highlight = "_kg-4";
export var resultIcon = "_kg-5";
export var resultItem = "_kg-7";
export var resultSubtitle = "_kg-3";
export var resultTitle = "_kg-2";
export var resultsList = "_kg-1";
export var searchGroup = "_kg-6";
export var selected = "_kg-8";